<template>
	<div class="study">
		<publicHeader></publicHeader>
		<careerHeader :careerNav ="careerNav"></careerHeader>
		<div class="major w1200">
			<div class="flex famous_position">
				<div class="my_position_l cl_gray">
					<img src="../../../static/icon_position.png" class="mar5" />
					<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/career" class="cl_gray">生涯规划</router-link>
					  >  <router-link to="/treasury" class="cl_gray">生涯宝库</router-link>  >  
						<router-link to="/treasury_major" class="cl_gray" v-if="type==1">专业信息库</router-link>
						<router-link :to="{ path: '/treasury_career', query: { currenCate: 0}}" class="cl_gray" v-if="type==2">职业信息库</router-link>
						<router-link to="/treasury_career" class="cl_gray" v-if="type==3">热门职业精读</router-link>
						<router-link to="/treasury_un" class="cl_gray" v-if="type==4">院校信息库</router-link>
						>  <span v-if="type==1">{{cont.name}}</span>
						<span v-if="type==2">{{zhiye.name}}</span>
						<span v-if="type==3">{{remen.name}}</span>
						<span v-if="type==4">{{yx.name}}</span></p>
				</div>
				<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
			</div>
			<div class="details" v-if="type==1">
				<div class="details_info">
					<div class="details_video mab20" v-if="cont.video != null">
						<img src="../../../static/video_bg.png" class="block details_video_bg" @click="videoTrue = true" v-show="!videoTrue" />
						<video-player v-show="videoTrue" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
					</div>
					<h3 class="f26px">{{cont.name}}</h3>
					<div class="details_info_div cl_dark mat10">
						<p>所属类别：{{cont.major_cate_name}}</p>
						<p>年限：{{cont.year}}</p>
						<p>学位：{{cont.degree}}</p>
					</div>
				</div>
				<div class="details_item" v-if="cont.goal != ''">
					<div class="details_item_title f20px cl_dark">培养目标</div>
					<div class="details_item_cont cl_gray" v-html="cont.goal"></div>
				</div>
				<div class="details_item" v-if="cont.require != ''">
					<div class="details_item_title f20px cl_dark">培养要求</div>
					<div class="details_item_cont cl_gray" v-html="cont.require"></div>
				</div>
				<div class="details_item" v-if="cont.ability != ''">
					<div class="details_item_title f20px cl_dark">毕业应获得能力</div>
					<div class="details_item_cont cl_gray" v-html="cont.ability"></div>
				</div>
				<div class="details_item" v-if="cont.class != ''">
					<div class="details_item_title f20px cl_dark">开设课程</div>
					<div class="details_item_cont cl_gray" v-html="cont.class"></div>
				</div>
				<div class="details_item" v-if="JSON.stringify(cont.alike_data) != '[]'">
					<div class="details_item_title f20px cl_dark">相近专业</div>
					<div class="details_item_zy cl_gray">
						<div class="details_zy_list mab10" v-for="(item,index) in cont.alike_data" :key="index">
							<p v-if="item.id == null">{{item.name}}</p>
							<router-link class="cl_violet" :to="{ path: '/treasury_details', query: { id: item.id, type: 1}}" v-else>{{item.name}}</router-link>
						</div>
					</div>
				</div>
				<div class="details_item" v-if="cont.quality != ''">
					<div class="details_item_title f20px cl_dark">素质能力要求</div>
					<div class="details_item_cont cl_gray" v-html="cont.quality"></div>
				</div>
				<div class="details_item" v-if="JSON.stringify(cont.school_data) != '[]'">
					<div class="details_item_title f20px cl_dark">优势院校</div>
					<div class="details_item_zy cl_gray">
						<div class="details_zy_list mab10" v-for="(item,index) in cont.school_data" :key="index">
							<p v-if="item.id == null">{{item.name}}</p>
							<router-link class="cl_violet" :to="{ path: '/teeasury_details', query: { id: item.id, type: 4}}" v-else>{{item.name}}</router-link>
						</div>
					</div>
				</div>
				<div class="details_item" v-if="cont.job != ''">
					<div class="details_item_title f20px cl_dark">就业方向</div>
					<div class="details_item_cont cl_gray" v-html="cont.job"></div>
				</div>
			</div>
			<div class="details" v-else-if="type==2">
				<div class="details_info">
					<h3 class="f26px">{{zhiye.name}}</h3>
					<div class="details_info_div cl_dark mat10">
						<p>所属行业：{{zhiye.base_post_cate_name}} > {{zhiye.post_cate_name}}</p>
					</div>
				</div>
				<div class="details_item" v-if="zhiye.intro != ''">
					<div class="details_item_title f20px cl_dark">职业简介</div>
					<div class="details_item_cont cl_gray" v-html="zhiye.intro"></div>
				</div>
				<div class="details_item" v-if="zhiye.content != ''">
					<div class="details_item_title f20px cl_dark">工作内容</div>
					<div class="details_item_cont cl_gray" v-html="zhiye.content"></div>
				</div>
				<div class="details_item" v-if="zhiye.require != ''">
					<div class="details_item_title f20px cl_dark">从业资格</div>
					<div class="details_item_cont cl_gray" v-html="zhiye.require"></div>
				</div>
				<div class="details_item" v-if="zhiye.future != ''">
					<div class="details_item_title f20px cl_dark">发展现状及前景</div>
					<div class="details_item_cont cl_gray" v-html="zhiye.future"></div>
				</div>
				<div class="details_item" v-if="zhiye.tip != ''">
					<div class="details_item_title f20px cl_dark">小贴士</div>
					<div class="details_item_cont cl_gray" v-html="zhiye.tip"></div>
				</div>
				<div class="details_item" v-if="zhiye.example != ''">
					<div class="details_item_title f20px cl_dark">职业发展案例</div>
					<div class="details_item_cont cl_gray" v-html="zhiye.example"></div>
				</div>
			</div>
			<div class="details" v-else-if="type==3">
				<div class="details_remen_info flex">
					<div class="details_remen_info_l">
						<h3 class="f26px">{{remen.name}}</h3>
						<p class="cl_dark mat10">{{remen.intro}}</p>
					</div>
					<img :src="remen.pic" class="details_remen_info_r" />
				</div>
				<div class="details_item" v-if="remen.duty != ''">
					<div class="details_item_title f20px cl_dark">任务职责</div>
					<div class="details_item_cont cl_gray" v-html="remen.duty"></div>
				</div>
				<div class="details_item" v-if="remen.edu_need != ''">
					<div class="details_item_title f20px cl_dark">学历要求</div>
					<div class="details_item_cont cl_gray" v-html="remen.edu_need"></div>
				</div>
				<div class="details_item" v-if="remen.major_need != ''">
					<div class="details_item_title f20px cl_dark">专业要求</div>
					<div class="details_item_cont cl_gray" v-html="remen.major_need"></div>
				</div>
				<div class="details_item" v-if="remen.pro_know_need != ''">
					<div class="details_item_title f20px cl_dark">专业知识背景</div>
					<div class="details_item_cont cl_gray" v-html="remen.pro_know_need"></div>
				</div>
				<div class="details_item" v-if="remen.industry_know_need != ''">
					<div class="details_item_title f20px cl_dark">行业知识背景</div>
					<div class="details_item_cont cl_gray" v-html="remen.industry_know_need"></div>
				</div>
				<div class="details_item" v-if="remen.course != ''">
					<div class="details_item_title f20px cl_dark">大学课程</div>
					<div class="details_item_cont cl_gray" v-html="remen.course"></div>
				</div>
				<div class="details_item" v-if="remen.tool != ''">
					<div class="details_item_title f20px cl_dark">常用工具</div>
					<div class="details_item_cont cl_gray" v-html="remen.tool"></div>
				</div>
				<div class="details_item" v-if="remen.skill_pro != ''">
					<div class="details_item_title f20px cl_dark">专业技能</div>
					<div class="details_item_cont cl_gray" v-html="remen.skill_pro"></div>
				</div>
				<div class="details_item" v-if="remen.skill_com != ''">
					<div class="details_item_title f20px cl_dark">通用技能</div>
					<div class="details_item_cont cl_gray" v-html="remen.skill_com"></div>
				</div>
				<div class="details_item" v-if="remen.future_industry != ''">
					<div class="details_item_title f20px cl_dark">行业发展前景</div>
					<div class="details_item_cont cl_gray" v-html="remen.future_industry"></div>
				</div>
				<div class="details_item" v-if="remen.future_person != ''">
					<div class="details_item_title f20px cl_dark">个人发展路径</div>
					<div class="details_item_cont cl_gray" v-html="remen.future_person"></div>
				</div>
				<div class="details_item" v-if="remen.future_post != ''">
					<div class="details_item_title f20px cl_dark">职业的就业趋势</div>
					<div class="details_item_cont cl_gray" v-html="remen.future_post"></div>
				</div>
				<div class="details_item" v-if="JSON.stringify(remen.album) != '[]'">
					<div class="details_item_title f20px cl_dark">工作环境</div>
					<div class="details_item_img">
						<img :src="item" v-for="(item,index) in remen.album" :key="index" />
					</div>
				</div>
			</div>
			<div class="details" v-else-if="type==4">
				<div class="details_yx_info">
					<img :src="yx.icon" class="details_yx_info_img" />
					<div class="details_yx_info_r cl_dark">
						<h3 class="f26px">{{yx.name}}</h3>
						<div class="yx_info_item_cont mat10">
							<p class="yx_info_item">类型：{{yx.type}}</p>
							<p class="yx_info_item">隶属：{{yx.belong}}</p>
							<p class="yx_info_item">大学排名：<span class="cl_red">{{yx.nation_rank}}</span></p>
							<p class="yx_info_item">层次：{{yx.level}} | {{yx.featureList}}</p>
						</div>
						<h4 class="mat5">院校官网：<i @click="toWeb(yx.web)" class="cl_blue">{{yx.web}}</i></h4>
					</div>
				</div>
				<div class="details_item">
					<div class="details_item_title f20px cl_dark" v-if="yx.intro != ''">学校简介</div>
					<div class="details_item_cont cl_gray" v-html="yx.intro"></div>
				</div>
				<div class="details_item" v-if="JSON.stringify(yx.major) != '[]'">
					<div class="details_item_title f20px cl_dark">高等院校特色专业</div>
					<div class="details_item_zy cl_gray">
						<div class="details_zy_list mab10" v-for="(item,index) in yx.major" :key="index">
							<p>· {{item}}</p>
						</div>
					</div>
				</div>
				<div class="details_item" v-if="yx.fee != ''">
					<div class="details_item_title f20px cl_dark">学费</div>
					<div class="details_item_cont cl_gray" v-html="yx.fee"></div>
				</div>
				<div class="details_item" v-if="yx.city_feature != ''">
					<div class="details_item_title f20px cl_dark">城市特点</div>
					<div class="details_item_cont cl_gray" v-html="yx.city_feature"></div>
				</div>
			</div>
		</div>
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import careerHeader from '../../components/career_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'treasury_details',
		components: {
			publicHeader,
			careerHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				careerNav: 2,	//导航
				type: "", //1专业2职业3热门4院校
				id: "",
				cont: {},//专业
				zhiye: {}, //职业
				remen: {}, //热门
				yx: {}, //院校
				videoTrue: false,
				playerOptions: {
					//播放速度
					playbackRates: [0.5, 1.0, 1.5, 2.0], 
					//如果true,浏览器准备好时开始回放。
					autoplay: false, 
					// 默认情况下将会消除任何音频。
					muted: false, 
					// 导致视频一结束就重新开始。
					loop: false, 
					// 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					preload: 'auto', 
					language: 'zh-CN',
					 // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					aspectRatio: '16:9',
					 // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					fluid: true,
					sources: [{
							//类型
							type: "video/mp4",
							//url地址
							src: "http://cart.mixsail.com/upload/admin/upload/add_pic/20201107/5fa63f05b96eb.mp4",
					}],
					//你的封面地址
					poster: '',
					//允许覆盖Video.js无法播放媒体源时显示的默认信息。
					notSupportedMessage: '此视频暂无法播放，请稍后再试',
					controlBar: {
							timeDivider: true,
							durationDisplay: true,
							remainingTimeDisplay: false,
							//全屏按钮
							fullscreenToggle: true  
					}
				},
			}
		},
		mounted() {
			
		},
		created() {
			var that = this;
			that.id = that.$route.query.id;
			that.type = that.$route.query.type;
			if (that.type == 1) {
				that.getInfo();
			} else if (that.type == 2) {
				that.getZhiye();
			} else if (that.type == 3) {
				that.getRemen();
			} else if (that.type == 4) {
				that.getYz();
			}
		},
		watch: {
			$route: {
				handler () {
					var that = this;
					that.id = that.$route.query.id;
					that.type = that.$route.query.type;
					if (that.type == 1) {
						that.getInfo();
					} else if (that.type == 2) {
						that.getZhiye();
					} else if (that.type == 3) {
						that.getRemen();
					} else if (that.type == 4) {
						that.getYz();
					}
					
				}
			}
		},
		methods: {
			//获取专业数据
			getInfo () {
				var that = this;
				that.$get("/api/careerbible/get_major_del_data",{
					id: that.id
				})
				.then(res => {
					that.cont = res.data;
					that.playerOptions.sources[0].src = that.cont.video;
				});
			},
			//获取职业数据
			getZhiye () {
				var that = this;
				that.$get("/api/careerbible/get_post_del_data",{
					id: that.id
				})
				.then(res => {
					that.zhiye = res.data;
				});
			},
			//获取热门职业数据
			getRemen () {
				var that = this;
				that.$get("/api/careerbible/get_hot_post_del_data",{
					id: that.id
				})
				.then(res => {
					that.remen = res.data;
				});
			},
			//获取院校数据
			getYz () {
				var that = this;
				that.$get("/api/careerbible/get_university_del_data",{
					id: that.id
				})
				.then(res => {
					that.yx = res.data;
					that.yx.featureList = that.yx.feature.replace(/,/g, " | ")
				});
			},
			
			toWeb (e) {
				window.open(e,"_blank");
			},
		},
	}
</script>

<style>
</style>
